import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { IoIosCheckmarkCircleOutline, IoIosCloseCircleOutline } from "react-icons/io";
import Btn from '../buttons/buttons';
import Tab from './tab';
import s from "./tabs.module.css";
import slugify from "slugify"


const Alert = (props) => {
  const containsCorreoNoExiste =
  props.content?.props?.dangerouslySetInnerHTML?.__html?.toLowerCase().includes(
    "correo registrado no existe"
  );

  return (
    <div className='center'>
    {props.type === 'error' ?
      <React.Fragment>
        <IoIosCloseCircleOutline className='f-7 c-red-0' />
        <p className='c-red-0 fw--1 f-3'>{props.title}</p>
        {props.content}
        {props.selectedTipoCliente === "NC" ? null : (props.isLibrodeReclamaciones && containsCorreoNoExiste) ? <Btn size='medium' label='Actualizar datos' type="button" className="mr-3" onClick={() => window.open('https://misdatos.prima.com.pe/actualizacion-datos-biometria', '_blank')} /> : null}
        <Btn size='medium' label='Intentar de nuevo' type="button" onClick={() => window.location.reload(false)/*props.tryAgain()*/} />
      </React.Fragment>
      : null}
    {props.type === 'success' ?
      <React.Fragment>
        <IoIosCheckmarkCircleOutline className='f-7 c-green-0' />
        <p className='c-green-0 fw--1 f-3 mb-3'>{props.title}</p>
        {props.content}
      </React.Fragment>
      : null}
  </div>
  )
}

class Tabs extends Component {
  static propTypes = {
    children: PropTypes.instanceOf(Array).isRequired,
    GTMoption:PropTypes.any
  }

  

  constructor(props) {
    super(props);
    this.state = {
      hasEnded: false,
      activeTab: this.props.children[0].props.label,
      indexTab: 0
    };
  }

  currentIndex = () => this.props.children.findIndex((item) => { return item.props.label === this.state.activeTab })

  onClickTabItem = (tab, behavior) => {
    this.setState({ activeTab: tab });
  }

  toFinishTabs = () => {
    const itemsLength = this.props.children.length;
    this.setState((prevState) => {
      const indexLessThanLength = this.currentIndex() < itemsLength - 1
      return {
        activeTab: this.props.children[indexLessThanLength ? this.currentIndex() + 1 : this.currentIndex()].props.label,
        hasEnded: indexLessThanLength ? false : true
      }
    })
  }

  
  tryAgain = () => {
       
    
    this.setState(() => {
      return {
        activeTab: this.props.children[0].props.label,
        hasEnded: false
      }
    });  
  }


  onClickNext = () => {
    window.scrollTo(0, 0);
    if (this.props.onNext) {
      const result = this.props.onNext(this.currentIndex());
      if (!result) {
        return;
      }
    }
    this.toFinishTabs();
  }

  onClickBack = () => {
    this.setState((prevState) => {
      return {
        activeTab: this.props.children[this.currentIndex() > 0 ? this.currentIndex() - 1 : this.currentIndex()].props.label,
      }
    })
  }

  render() {
    const {
      onClickTabItem,
      onClickNext,
      onClickBack,
      currentIndex,
      tryAgain,
      props: {
        children,
        layout,
        behavior,
        alertType,
        alertTitle,
        alertBody,
        className,
        isAsync,
        loading,
        GTMoption,
        isLibrodeReclamaciones = false,
        selectedTipoCliente = ""
      },
      state: {
        activeTab
      }
    } = this;

    const hasEnded = isAsync ? this.props.hasEnded : this.state.hasEnded;

    return (
      <div className={`${className} ${s.tabs}`}>
        {!hasEnded ?
          <div className={layout === 'full-width' ? 'bg-white' : s.tabNavWrapper}>
            <ol className={`flex ${s.tabbar}`}>
              {children.map((child, index) => {
                const { label, icon } = child.props;
                return (
                  <Tab
                    GTMoption={GTMoption}
                    layout={layout}
                    activeTab={activeTab}
                    key={label}
                    label={label}
                    icon={icon}
                    behavior={behavior}
                    onClick={onClickTabItem}
                    isDisabled={index > currentIndex()}
                    isFill={index < currentIndex()}
                  />
                );
              })}
            </ol>
          </div>
          : null
        }
        <div className={`${layout === 'full-width' ? 'pa-3 pa-4@md' : 'ph-3 ph-4@md bg-white pv-4@md'} tab-content  pv-3 `}>
          {children.map((child, index) => {
            if (child.props.label !== activeTab) return undefined;
            if (hasEnded) return <Alert isLibrodeReclamaciones={isLibrodeReclamaciones} selectedTipoCliente={selectedTipoCliente} title={alertTitle} key={index} content={alertBody} type={alertType} tryAgain={tryAgain} />
            return child.props.children;
          })}
          {
            behavior === 'steps' && !hasEnded ?

              <div className='flex justify-between mt-5 items-center'>
                <Btn color='white' className='mr-4' label='Atrás' type='button' size='medium' onClick={onClickBack} />
                {
                  this.props.children.length - 1 === currentIndex() ?
                    this.props.customEndBtn ? this.props.customEndBtn : 
                    <Btn id={`${slugify(this.props.children[this.props.children.length - 1]['props']['label'])}-finalizar`} label={this.props.loading ? 'Procesando...' : 'Finalizar'} type='button' size='medium' onClick={onClickNext} /> :
                    <Btn label='Siguiente' type='button' size='medium' onClick={onClickNext} />

                }
              </div>
              : null
          }
        </div>
      </div>
    );
  }
}

Tabs.defaultProps = {
  endButtonId: false,
  className: '',
  alertType: 'success',
  alertTitle: 'Hemos recibido tu mensaje',
  alertBody: <p className='mv-3'>Nos pondremos en contacto contigo pronto.</p>,
  GTMoption:{section:'',sub_section:'', option:'', local:''}
};


export default Tabs;
